import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'linaria';
import classnames from 'classnames';
const modalTabStyles = "m285iru";
export const ModalTabs = ({
  children,
  hasBorder,
  isSticky,
  className
}) => {
  return <div className={classnames(modalTabStyles, {
    bordered: hasBorder,
    sticky: isSticky
  }, className)}>
      {children}
    </div>;
};
ModalTabs.propTypes = {
  hasBorder: PropTypes.bool,
  isSticky: PropTypes.bool
};
ModalTabs.defaultProps = {
  hasBorder: true,
  isSticky: true
};
export default ModalTabs;

require("./modal-tabs.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./modal-tabs.js");